module.exports = __webpack_public_path__ + "static/img/p000.4ed4f73.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/p000.png
// module id = brlD
// module chunks = 0